export enum ITimelineLayers {
  Thumbnails = 'Thumbnails',
  ProgramsTiming = 'ProgramsTiming',
  Markups = 'Markups',
  Comments = 'Comments',
  Audio = 'Audio',
  Subtitles = 'Subtitles'
}
